export default __webpack_public_path__ + "static/media/case-scenario.119ebf7d.svg";